
let dengageInitialized = false;
let notificationRequested = false;

const isLocalStorageAvailable = () => {
  try {
    const testKey = '__localStorage_test__';
    window.localStorage.setItem(testKey, 'test');
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

const isSafari = () => {
  return (/^((?!chrome|android).)*safari/i).test(navigator.userAgent);
};

export const initDengage = () => {
  if (!window?.dengage || dengageInitialized) {
    return null;
  }
  
  try {
    dengageInitialized = true;
    
    if (!notificationRequested) {
      const hasAskedBefore = isLocalStorageAvailable()
        ? localStorage.getItem('dengage_notification_asked')
        : null;
      
      const notificationPermission = typeof Notification !== 'undefined'
        ? Notification?.permission
        : null;
      
      if (!hasAskedBefore && notificationPermission !== 'granted' && notificationPermission !== 'denied') {
        const delay = isSafari() ? 3000 : 2000;
        setTimeout(() => {
          try {
            window.dengage('showNativePrompt');
            if (isLocalStorageAvailable()) {
              localStorage.setItem('dengage_notification_asked', 'true');
            }
            notificationRequested = true;
          } catch (error) {
            console.warn('Dengage notification prompt error:', error);
          }
        }, delay);
      } else if (notificationPermission === 'granted') {
        notificationRequested = true;
      }
    }
  } catch (error) {
    console.warn('Dengage initialization error:', error);
  }
};


export const getToken = () => {
  if (!window?.dengage) {
    return null;
  }
  
  try {
    window.dengage('getToken', function (token) {
      if (token == null) {
        console.log(1);
      } else {
        console.log(2, token);
      }
    });
  } catch (error) {
    console.warn('Dengage getToken error:', error);
  }
};

export const setContactKey = userId => {
  if (!window?.dengage) {
    return null;
  }
  
  try {
    initDengage();
    window.dengage('setContactKey', userId);
  } catch (error) {
    console.warn('Dengage setContactKey error:', error);
  }
};

export const requestNotificationPermission = () => {
  if (!window?.dengage || !dengageInitialized) {
    return null;
  }
  
  try {
    window.dengage('showNativePrompt');
  } catch (error) {
    console.warn('Dengage requestNotificationPermission error:', error);
  }
};


export const getContactKey = () => {
  if (!window?.dengage) {
    return null;
  }
  
  try {
    window.dengage('getContactKey', function (userId) {
      console.log('userID => ', userId);
    });
  } catch (error) {
    console.warn('Dengage getContactKey error:', error);
  }
};

export const setPageView = page_type => {
  if (!window?.dengage) {
    return null;
  }
  
  try {
    window.dengage('ec:pageView', {
      page_type: page_type
    });
  } catch (error) {
    console.warn('Dengage setPageView error:', error);
  }
};

export const cartEvents = ({
  identifier,
  type,
  game_type,
  total_coupon_amount,
  coupon_id
}) => {
  if (!window?.dengage) {
    return null;
  }

  try {
    var eventData = {
      identifier,
      type,
      game_type,
      total_coupon_amount,
      coupon_id
    };
    window.dengage('sendDeviceEvent', 'cart_events', eventData);
  } catch (error) {
    console.warn('Dengage cartEvents error:', error);
  }
};

export const cartEventsDetail = ({
  identifier,
  event_name,
  event_id,
  sport_type,
  market_name,
  market_value,
  coupon_id,
  total_coupon_amount
}) => {
  if (!window?.dengage) {
    return null;
  }

  try {
    var eventData = {
      identifier,
      event_name,
      event_id,
      sport_type,
      market_name,
      market_value,
      coupon_id,
      total_coupon_amount,
    };
    window.dengage('sendDeviceEvent', 'cart_events_detail', eventData);
  } catch (error) {
    console.warn('Dengage cartEventsDetail error:', error);
  }
};

export const campaing = (utmSource, utmMedium, utmCampaing) => {
  if (!window?.dengage) {
    return null;
  }

  try {
    var eventData = {
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaing: utmCampaing
    };
    window.dengage('sendDeviceEvent', 'cart_events', eventData);
  } catch (error) {
    console.warn('Dengage campaing error:', error);
  }
};
 

export const tribunShare = ({
  coupon_id,
  share_source
}) => {
  if (!window?.dengage) {
    return null;
  }

  try {
    var eventData = {
      identifier: coupon_id,
      coupon_id,
      share_source,
      type: 'tribun_share',
    };
    window.dengage('sendDeviceEvent', 'cart_events', eventData);
  } catch (error) {
    console.warn('Dengage tribunShare error:', error);
  }
};
